// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-8018fa00] .el-input-group__append {\r\n  padding: 0 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
